import {Component, input} from '@angular/core';
import {NgIf} from "@angular/common";
import {MatProgressBarModule} from '@angular/material/progress-bar';

@Component({
  selector: 'app-cards-basic',
  standalone: true,
    imports: [
      MatProgressBarModule,
      NgIf
    ],
  templateUrl: './cards-basic.component.html',
  styleUrl: './cards-basic.component.css'
})
export class CardsBasicComponent {
  title = input();
  description = input();
  loading = input(false);
}
